import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { OrderService } from '../../services';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-error-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './error-modal.component.html',
  styleUrl: './error-modal.component.scss'
})
export class ErrorModalComponent implements OnInit, OnDestroy {
  @ViewChild('errorModal', { static: false }) modal: ElementRef;

  public errorText: string = '';
  public notFound: boolean = false;
  public barcode: string = '';

  private $errorMessage: Subscription;

  constructor() { }

  ngOnInit(): void {
    this.$errorMessage = OrderService.errorMessage.subscribe(res => {
      if (res) {
        this.initModal(res);
      }
      else {
        this.errorText = '';
      }
    });
  }

  private initModal(err: HttpErrorResponse) {
    console.log(err);
    OrderService.loading.next(false);
    if (err.status == 422) {
      this.notFound = true;
      this.barcode = err.error.barcode;
    }
    this.errorText = err.status + ' ' + (err.error.message || err.error.calculateOrder.message);
  }

  public close() {
    this.modal.nativeElement.classList.add('close')
    setTimeout(() => {
      this.errorText = '';
      this.notFound = false;
      this.barcode = '';
      OrderService.errorMessage.next(null);
      this.modal.nativeElement.classList.remove('close')
    }, 300);
  }

  ngOnDestroy(): void {
    this.$errorMessage.unsubscribe();
  }
}
